module.exports = __webpack_public_path__ + "img/ship-3d.3b2a119e.png";